import { install } from '@wix/ambassador-devcenter-site-apps-v1-app/http';
export const httpInstallApp = async params => {
  const {
    httpClient,
    appDefId
  } = params;
  const response = await (httpClient == null ? void 0 : httpClient.request(install({
    apps: [{
      id: appDefId
    }]
  })));
  return response;
};
//# sourceMappingURL=httpInstallApp.js.map